import { makeStyles } from '@material-ui/core';

export const MemberResponsibleStyle = makeStyles({
    root: {
        marginLeft: '24px',
        marginBottom: '16px',
    },
});
